<template>
    <div>
        <modal class="new-modal-default reject-popup" :name="modal_name" transition="nice-modal-fade" :delay="100" :width="500"
            :height="325" :pivot-y="0.5" :adaptive="true" :scrollable="false" style="pointer-events:inherit !important" v-bind:click-to-close="false">
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <!-- Header Section -->
                <div class="v-modal-header">
                    <div></div>
                    <div>
                        <span class="v-modal-dialog-title v-modal-title">REQUEST TO DOWNLOAD</span>
                    </div>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left" @click="closeModal"></span>
                    </div>
                </div>
                <!-- Body Section -->
                <div class="v-modal-body pb-0" style="height:auto;">
                    <div class="v-modal-layout px-2">
                        <div class="w-100 mt-4">
                            <span class="text-secondary fs-14 fw-600 mr-2">Manager's Email ID<sup class="fs-14 pl-1 text-danger">*</sup></span>
                            <div class="d-flex align-content-center mt-2">
                                <multiselect :loading="manager_loading" class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2"
                                v-validate="'required'" label="full_name" :searchable="true" @select="selectedManager($event)"
                                :options="manager_name_options" name="manager_name" @search-change="searchManager()"
                                v-model="manager_email" placeholder="Select Manager">
                                    <template slot="noResult">
                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                    </template>
                                    <template slot="afterList">
                                        <div v-observe-visibility="reachedEndOfManager" />
                                    </template>
                                </multiselect>
                            </div>
                            <div class="text-right pr-10">
                                <span class="float-left text-danger mb-3" v-show="errors.has('manager_name')">This Field is Required</span>
                            </div>
                        </div>
                        <div class="w-100 mt-6 pt-2">
                            <span class="text-secondary fs-14 fw-600 mr-2">Message </span>
                            <div class="mt-1">
                                <textarea-autosize class="bg-transparent px-2 pt-1 pb-6 mt-1 description" name="description" v-model="description"
                                    placeholder="Enter Message"
                                    :min-height="100"
                                    :max-height="100"
                                    maxlength="1000"/>
                            </div>
                            <div class="d-flex justify-content-end">
                                <div>
                                    <span>{{ description.length }}/1000</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Buttons Section -->
                <div v-if="disableButtonAndDisplayLoader == false" class="v-modal-dialog-actions d-flex justify-content-center align-items-center pt-0">
                    <button class="btn new-cancel-button ml-2 mr-2" @click="closeModal">Cancel</button>
                    <button class="btn new-save-button ml-2 mr-2" @click="validateData()">Send</button>
                </div>
                <div v-else class="v-modal-dialog-actions d-flex justify-content-center align-items-center pt-0">
                    <button class="btn btn-des-small ml-2 mr-2 btn-new-cancel" style="border: 1px solid transparent;" disabled>Cancel</button>
                    <button class="btn btn-des-small ml-2 mr-2 btn-new-save" style="border: 1px solid transparent;position: relative;" disabled>Send
                        <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                    </button>
                </div>
            </div>
        </modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>

<script>
import { HollowDotsSpinner } from "epic-spinners";
import leads from "../mixins/leads"
import requests from "../mixins/requests"
import { SweetModal } from 'sweet-modal-vue';
import { debounce } from 'lodash'
export default {
    props: ['modal_name','selectedLeads','leadsToShow'],
    data(){
        return {
            disableButtonAndDisplayLoader: false,
            success_msg:"",
            warning_msg:"",
            description: "",
            manager_email: "",
            manager_loading: false,
            manager_count: 0,
            manager_scrollable: false,
            manager_visible: '',
            manager_name_options: [],
            temp_manager: [],
            selected_manager: [],
        }
    },
    mixins:[leads,requests],
    components:{
        SweetModal,
        HollowDotsSpinner
    },
    methods: {
        closeModal() {
            this.$emit("hideDownloadExcel");
        },
        closeModalAfter() {
            this.$emit("hideDownloadExcelAfter");
        },
        selectedManager(data){
            this.selected_manager = data;
        },
        async searchManagerDebouncer(item) {
            this.manager_name_options = [];
            this.manager_loading = true
            let response = await this.getEmployeeRoles({
                limit: 10,
                skip: 0,
                search_key: item,
                user_role: 'sales_manager',
                product_id: this.loggedInUser.product_id
            })
            this.manager_name_options = response.response
            this.manager_count = this.manager_count
            this.manager_loading = false
            this.manager_scrollable = false
        },
        async reachedEndOfManager(reached) {
            this.manager_visible = reached
            if (reached) {
                if (this.manager_scrollable == false) {
                    this.manager_loading = true
                    let response = await this.getEmployeeRoles({
                        skip: this.manager_count,
                        limit: 10,
                        search_key: "",
                        user_role: 'sales_manager',
                        product_id: this.loggedInUser.product_id
                    })
                    this.temp_manager = response.response.length;
                    if (response.skip == this.manager_count) {
                        if (this.temp_manager > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.manager_name_options.push(el);
                            });
                            this.manager_count += response.response.length;
                            this.manager_loading = false
                        } else {
                            this.manager_scrollable = true
                            this.manager_loading = false
                        }
                    }
                    this.manager_loading = false
                }
            }
        },
        validateData(){
            this.$validator.validateAll().then(async result => {
                if(result == true){
                    this.sendDownloadRequest();
                }
            })
        },
        async sendDownloadRequest(){
            this.disableButtonAndDisplayLoader = true;
            let lead_type = this.leadsToShow.toLowerCase();
            if(lead_type == 'manual'){
                lead_type = 'active'
            }
            try{
                let params = {
                    approver_email: this.selected_manager.email,
                    approver_id: this.selected_manager.user_id,
                    approver_full_name: this.selected_manager.full_name,
                    message: this.description,
                    lead_type: lead_type,
                    lead_ids: this.selectedLeads,
                }
                let response
                if(lead_type == 'active'){
                response = await this.callActiveLeadDownloadRequestAPI(params)
                } else if(lead_type == 'archive'){
                    response = await this.callArchiveLeadDownloadRequestAPI(params)
                } else if(lead_type == 'converted'){
                    response = await this.callConvertedLeadDownloadRequestAPI(params)
                }
                if (response.status_id == 1) {
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.disableButtonAndDisplayLoader = false;
                        this.closeModalAfter();
                        this.$refs.success_modal.close();
                    }, 3000);
                } else {
                    this.warning_msg = response.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.disableButtonAndDisplayLoader = false;
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            }catch(error){
                this.warning_msg = error
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.disableButtonAndDisplayLoader = false;
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        }
    },
    mounted(){
    },
    cretaed(){
        this.searchManager = debounce(this.searchManagerDebouncer, 500)
    },
    computed: {
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
    },
}
</script>
<style scoped>
    .btn-new-cancel {
        color: #fff;
        background-color: #E64646;
        border-radius: 5px;
        text-transform: none;
        font-weight: 500;
        border: 2px solid #E64646;
        line-height: 30px;
        box-shadow: none;
    }
    .btn-new-save {
        border: 2px solid #005dae;
        color:#fff;
        line-height: 30px;
        border-radius: 5px;
        background-color: #005dae;
        text-transform: capitalize;
    }
    .description{
        border: solid 1px #000 !important;
        border-radius: 5px!important;
        color: #000000;
        width: 100%;
    }
    .input-field {
        border-radius: 6px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px;
    }
    .input-width {
        border-radius: 5px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Leads/DownloadExcelModal.vue